import { useState } from 'react';
import { getCustomerPaymentCards } from '../../../services/customer/profileServices';

function useCustomerPaymentCards() {
  const [paymentCards, setPaymentCards] = useState([]);

  const fetchCards = async () => {
    const res = await getCustomerPaymentCards();
    setPaymentCards(res);
  };

  return { paymentCards, fetchCards };
}

export default useCustomerPaymentCards;
